<template>
    <div id="div_spRelatorioDinamico" ref="div_spRelatorioDinamico" class="relatorio-dinamico"
        :data-exec-mode="GET_execMode">
        <section class="relatorio-dinamico__header">
            <panelTitle>Editor de Laudo</panelTitle>

            <div class="actions">
                <configVisualizacaoRelatorioCMP v-show="currentExecMode == gConsts.rt.execModes.VIEW">
                </configVisualizacaoRelatorioCMP>

                <primaryButton v-if="currentExecMode == gConsts.rt.execModes.VIEW" @click="printReport">
                    <template #icon>
                        <PrintIconSvg />
                    </template>
                </primaryButton>

                <primaryButton @click="toggleExecMode" :isActive="currentExecMode == gConsts.rt.execModes.VIEW">
                    <template #icon>
                        <template v-if="currentExecMode == gConsts.rt.execModes.VIEW">
                            <EyeOffIconSvg width="16" height="16" />
                        </template>
                        <template v-else>
                            <EyeIconSvg width="16" height="16" />
                        </template>
                    </template>
                    Visualizar
                </primaryButton>
            </div>
        </section>

        <Divider />
        <!-- <section class="relatorio-dinamico-content">
            <rootNodeCMP v-for="(node, index) in GET_rootNodes" :key="node.id"
                :node="node"
                :execMode="currentExecMode"
                :id="node.id"
                :activeNode="node.id == activeNode?.step ? activeNode : null"
                :orderNumber="index + 1"
            ></rootNodeCMP>
        </section> -->

        <section ref="reportContent" class="relatorio-dinamico__content" id="relatorio" 
            :style="{ '--height-offset': `${footer.height}px` }"
            :data-exec-mode="currentExecMode" 
            :data-hide-section-title="GET_report_configVisualizacao_hideSectionTitle ? 'true' : 'false'"
            :data-hide-layer-title="GET_report_configVisualizacao_hideLayerTitle ? 'true' : 'false'"
            :data-show-label-color-square="GET_report_configVisualizacao_showLabelColorSquare ? 'true' : 'false'"
            :data-remove-label-annotation-style="GET_report_configVisualizacao_removeLabelAnnotationStyle ? 'true' : 'false'">
            <template v-for="(node, index) in rootReportNodes">
                <template v-if="node.layout.type == gConsts.node.layout.types.CUSTOM_LINE">
                    <customReportLineCMP :key="node.id" :execMode="currentExecMode" :reportCustomLine="node" :canEdit="canEditReport"></customReportLineCMP>
                </template>
                <template v-else>
                    <template v-if="index == 0 && canEditReport">
                        <custom-line-placeholder :key="`placeholder-before-${node.id}`" :orderIndex="-1" :parent="gConsts.node.layout.parents.ROOT" />
                    </template>
                    <rootReportLineCMP :key="node.id" :reportNode="node"
                        :execMode="currentExecMode" :id="node.id" :activeNode="node.id == activeNode?.step ? activeNode : null"
                        :orderNumber="index + 1" :canEdit="canEditReport">
                    </rootReportLineCMP>
                    <template v-if="canInsertCustomLineAfterNode(node) && canEditReport">
                        <custom-line-placeholder :key="`placeholder-after-${node.id}`" :orderIndex="node.order.index" :parent="gConsts.node.layout.parents.ROOT" />
                    </template>
                </template>
            </template>

            <!-- Linha de adicao de labels ao report -->
            <newReportLabelInput :isSticky="true" v-if="visible && currentExecMode == gConsts.rt.execModes.WORK && canEditReport"></newReportLabelInput>
            <!-- <newReportTermButtonCMP v-if="GET_execMode == gConsts.rt.execModes.WORK"></newReportTermButtonCMP> -->
        </section>
    </div>
</template>

// =========================================================================================
// =========================================================================================

<script>
import _ from 'lodash';
import rootReportLineCMP from '@/features/report/components/reportLine/rootReportLine.vue';
import newReportLabelInput from '../pesquisaAnotacoes/new-label/newReportLabelInput.vue';
// import newReportTermButtonCMP from './reportLine/newReportTermButton.vue';
import customReportLineCMP from '@/features/report/components/reportLine/customReportLine.vue';
import customLinePlaceholder from '@/features/report/components/reportLine/custom/customLinePlaceholder.vue';
import configVisualizacaoRelatorioCMP from './visualizacao/configVisualizacaoRelatorio.vue';
import { gConsts } from '@/globals/gConsts';
import { evtBus } from '@/main';
import { mapGetters, mapState, mapActions } from 'vuex';
import { exporter } from '@/mixins/exporter';


import EyeIconSvg from '@/assets/icons/eye.svg';
import PrintIconSvg from '@/assets/icons/print.svg';
import EyeOffIconSvg from '@/assets/icons/eye-off.svg';
import primaryButton from '@/components/ui/button/primaryButton.vue';
import panelTitle from '@/components/ui/panel/panelTitle.vue';
import Divider from '@/components/ui/divider.vue';

export default {
    name: 'relatorioDinamicoCMP',
    components: {
        rootReportLineCMP,
        newReportLabelInput,
        customReportLineCMP,
        EyeIconSvg,
        EyeOffIconSvg,
        PrintIconSvg,
        configVisualizacaoRelatorioCMP,
        customLinePlaceholder,
        primaryButton,
        panelTitle,
        Divider,
    },

    mixins: [exporter],

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    props: {
        active: Boolean,
        label: String,
        panelId: String,
        visible: Boolean,
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    data() {
        return {
            gConsts: gConsts,
            //            mouseInPanel : false
            activeNode: {
                step: null,
                layer: null,
                label: null,
            },
            currentExecMode: gConsts.rt.execModes.WORK,
            footer: {
                height: 0,
                observer: null,
            },
        };
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    computed: {
        ...mapState([
        ]),

        ...mapGetters([
            'GET_rootNodes',
            'GET_filteredNodes',
            'GET_execMode',
            'GET_reportNodes',
            'GET_reportNodes_validated',
            'GET_report_configVisualizacao_hideSectionTitle',
            'GET_report_configVisualizacao_hideLayerTitle',
            'GET_report_configVisualizacao_showLabelColorSquare',
            'GET_report_configVisualizacao_removeLabelAnnotationStyle'
        ]),

        reportCustomLinesMap() {
            const customReportLinesMap = this.GET_reportNodes
                .filter(node => node.layout.type == gConsts.node.layout.types.CUSTOM_LINE && node.layout.parent == gConsts.node.layout.parents.ROOT)
                .reduce((acc, node) => {
                    if (node.order.index == 0) {
                        acc.start = node;
                    } else if (node.order.index == 1) {
                        acc.end = node;
                    }
                    return acc;

                }, { start: null, end: null });
            return {
                start: customReportLinesMap.start ?? null,
                end: customReportLinesMap.end ?? null,
            }
        },

        rootReportNodes() {
            let reportNodes = this.GET_reportNodes;
            if (this.currentExecMode == gConsts.rt.execModes.VIEW) {
                reportNodes = this.GET_reportNodes_validated;
            }
            return reportNodes.filter(node => node.layout.parent == gConsts.node.layout.parents.ROOT)
                .sort((a, b) => a.order.index - b.order.index);
        },

        canEditReport() {
            return this.currentExecMode == gConsts.rt.execModes.WORK;
        }
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    watch: {
        // Quando os filtered nodes mudam, tenho que selecionar o 1o step novamente
        GET_filteredNodes(newFilteredNodes) {
            let firstRootNode = (this.GET_rootNodes.length > 0)
                ? this.GET_rootNodes[0]
                : null;

            if (firstRootNode == null)
                return;

            // evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: firstRootNode.id, nodeType: gConsts.node.layout.types.STEP });
        },
        GET_execMode(newExecMode) {
            this.currentExecMode = newExecMode;
        },

    },

    // -----------------------------------------------------------------

    methods: {
        ...mapActions([
            'ACT_reportNodes_addNewLabelReportText',
            'ACT_uiUpdate',
            'ACT_runtimeUpdate'
        ]),

        canInsertCustomLineAfterNode(node) {
            const foundIndex = this.rootReportNodes.findIndex(n => n.id == node.id);
            if (foundIndex == -1) {
                return false;
            }

            if (this.rootReportNodes[foundIndex + 1]?.layout?.type == gConsts.node.layout.types.CUSTOM_LINE) {
                return false;
            }

            return true;
        },

        toggleExecMode() {
            this.currentExecMode = (this.currentExecMode == gConsts.rt.execModes.WORK) ? gConsts.rt.execModes.VIEW : gConsts.rt.execModes.WORK;
            this.ACT_runtimeUpdate({ execMode: this.currentExecMode });
        },

        onActivateNode(payload) {
            var rootNode, layerNode, firstLabelNode;
            // console.log('relatorioDinamico.onActivateNode', payload);
            if (payload.nodeId == null && payload.nodeType == null)
                return;

            // Desativa tudo
            if (payload.nodeType == gConsts.node.layout.types.STEP && payload.nodeId == null) {
                this.activeNode.step = null;
                this.activeNode.layer = null;
                this.activeNode.label = null;
                this.ACT_runtimeUpdate({ active: this.activeNode });
                evtBus.$emit('evt_activateNode', this.activeNode);
                return;
            }

            var newActiveNode = this.GET_filteredNodes.find(node => node.id == payload.nodeId);

            if (!newActiveNode)
                return;

            // console.log('relatorioDinamico.onActivateNode.newActiveNode: ', newActiveNode);

            switch (payload.nodeType) {
                case gConsts.node.layout.types.LABEL:
                    if (newActiveNode.id == this.activeNode.label) {
                        this.activeNode.label = null;
                    } else {
                        layerNode = this.GET_filteredNodes.find(node => node.id == newActiveNode.layout.parent);
                        rootNode = this.GET_rootNodes.find(node => node.id == layerNode.layout.parent);
                        this.activeNode = {
                            step: rootNode.id,
                            layer: layerNode.id,
                            label: newActiveNode.id,
                        };
                    }
                    break;
                case gConsts.node.layout.types.LAYER:
                    if (newActiveNode.id == this.activeNode.layer) {
                        this.activeNode.layer = null;
                        this.activeNode.label = null;
                    } else {
                        rootNode = this.GET_rootNodes.find(node => node.id == newActiveNode.layout.parent);
                        firstLabelNode = this.GET_filteredNodes.find(node => node.layout.parent == newActiveNode.id)?.[0] ?? null;
                        this.activeNode = {
                            step: rootNode.id,
                            layer: newActiveNode.id,
                            label: firstLabelNode?.id ?? null,
                        };
                    }
                    break;
                case gConsts.node.layout.types.STEP:
                    if (newActiveNode.id == this.activeNode.step) {
                        this.activeNode.step = null;
                        this.activeNode.layer = null;
                        this.activeNode.label = null;
                    } else {
                        var layerId = null;
                        if (newActiveNode.id == 'step_denticao') {
                            layerId = 'layer_dentesSeg';
                        }

                        this.activeNode = {
                            step: newActiveNode.id,
                            layer: layerId,
                            label: null,
                        };
                    }
                    break;
            }

            this.ACT_runtimeUpdate({ active: this.activeNode });
            evtBus.$emit('evt_activateNode', this.activeNode);
        },

        observeFooterResize() {
            const footerElement = document.getElementById('footer');
            if (!footerElement)
                return;
            this.footer.observer = new ResizeObserver((entries) => {
                entries.forEach(entry => {
                    console.debug('relatorioDinamico.observeFooterResize: footer resized', entry.contentRect.height);
                    this.footer.height = entry.contentRect.height;
                });
            });
            this.footer.observer.observe(footerElement);
        },

        printReport() {
            this.printExam()
        }
    },

    // -----------------------------------------------------------------        

    mounted() {

        this.currentExecMode = this.GET_execMode;

        this.activeNode = {
            step: this.$store.state.runtime.active.step ?? null,
            layer: this.$store.state.runtime.active.layer ?? null,
            label: this.$store.state.runtime.active.label ?? null,
        }

        this.observeFooterResize();
    },

    beforeDestroy() {
        if (this.footer.observer) {
            console.debug('relatorioDinamico.beforeDestroy: disconnecting footer observer');
            this.footer.observer.disconnect();
        }
    },

    // -----------------------------------------------------------------        

    created() {
        evtBus.$on('evt_relatorioDinamico_activateNode', this.onActivateNode);

        // evtBus.$on('evt_tool_newTool', (payload) => {
        //     // Se criar um tool em cima de um label, adiciona o label no relatorio.
        //     if (this.activeNode.label == payload.tool_label_id && this.GET_reportNodes.find(reportNode => reportNode.id == payload.tool_label_id) == null) {
        //         this.ACT_reportNodes_addNewLabelReportText({ labelId: payload.tool_label_id });
        //         evtBus.$emit('evt_relatorioDinamico_addLabelToReport', { labelId: payload.tool_label_id });
        //     }
        // });
    }

    // -----------------------------------------------------------------

};
</script>

// =========================================================================================
// =========================================================================================

<style>
@import '../../../features/report/styles/shared/report.css';

.relatorio-dinamico {
    display: flex;
    flex-direction: column;
    user-select: auto;
    /* height: 100%; */
}

.relatorio-dinamico__header,
.relatorio-dinamico__content {
    padding: var(--spacing) var(--spacing-sl);
}

.relatorio-dinamico__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacing);
}

.relatorio-dinamico__header>.actions {
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
}

.relatorio-dinamico__header>.button:hover {
    opacity: 0.8;
}

.relatorio-dinamico__header>.button[data-is-active="true"] {
    background-color: var(--color-primary);
    color: var(--color-white);
}

.relatorio-dinamico__content {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm);
    overflow-y: auto;
    height: 100%;
    max-height: calc(100vh - 130px - var(--height-offset, 0px));
    /* Firefox scrollbar styling */
    scrollbar-width: thin;
    scrollbar-color: var(--color-black) transparent;
}

/* Webkit scrollbar styling */
.relatorio-dinamico__content::-webkit-scrollbar {
    width: 8px;
}

.relatorio-dinamico__content::-webkit-scrollbar-track {
    background: transparent;
}

.relatorio-dinamico__content::-webkit-scrollbar-thumb {
    background: var(--color-black);
    border-radius: var(--radius-sm);
}

.relatorio-dinamico__content::-webkit-scrollbar-thumb:hover {
    background: var(--color-black);
}

.relatorio-dinamico__content>.custom {
    padding-left: var(--spacing-sm);
}

.relatorio-dinamico[data-exec-mode="view"] {
    user-select: text;
    cursor: text;
}

/** Relatorio */

#relatorio[data-exec-mode="view"][data-hide-section-title="true"] {
    gap: 0;
}

#relatorio[data-exec-mode="view"][data-hide-section-title="false"]>.custom {
    padding-left: 0;
}

</style>